import { render } from "./detailBlog.vue?vue&type=template&id=4b9808bc"
import script from "./detailBlog.vue?vue&type=script&lang=js"
export * from "./detailBlog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__